import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import Notice from "components/tw/notice";
import { btnDangerCls, btnSecondaryCls } from "components/tw/classes";

interface CancelLeaveDialogProps {
  isWorking: boolean;
  /** Translation key of the line to show when the last try failed. */
  errorKey: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

/** «Atšaukti prašymą?»: one question before the person's own pending request is withdrawn. */
export default function CancelLeaveDialog({ isWorking, errorKey, onConfirm, onClose }: CancelLeaveDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open onClose={isWorking ? () => undefined : onClose} className="relative z-[1000]">
      <DialogBackdrop className="fixed inset-0 bg-zinc-950/40" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-sm space-y-4 rounded-xl bg-white p-5 shadow-xl">
          <DialogTitle className="text-base font-semibold text-gray-900">{t("leave_cancel_title")}</DialogTitle>
          <p className="text-sm text-gray-600">{t("leave_cancel_notice")}</p>
          {errorKey && <Notice tone="critical">{t(errorKey)}</Notice>}
          {/* On a phone the buttons are stacked, full width and apart; «Palikti» is the lower one. */}
          <div className="flex justify-end gap-2 max-md:flex-col-reverse max-md:gap-3">
            <button type="button" className={`${btnSecondaryCls} max-md:min-h-11 max-md:w-full`} disabled={isWorking} onClick={onClose}>
              {t("leave_cancel_keep")}
            </button>
            <button type="button" className={`${btnDangerCls} max-md:min-h-11 max-md:w-full`} disabled={isWorking} onClick={onConfirm}>
              {t("leave_cancel_confirm")}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
